import {JsonObject, JsonProperty, JsonSerializer, throwError} from "typescript-json-serializer";
import {ProjectProcess} from "../models/project-process";
import {Project} from "../models/project";
import {Auftragsverwaltung} from "../stores/auftragsverwaltung-mobx";
import {AppState} from "../components/app/app-mobx";

export interface ProcessHookProps {
    id: string;
    transitions: Array<[number, number]>;
}

export interface ProcessHookRunProps {
    process: ProjectProcess;
    project: Project;
    auftragsverwaltung: Auftragsverwaltung;
    appStore: AppState;
}

/**
 * Hooks die bei Statustransitionen von Prozessen ausgeführt werden können
 */
@JsonObject()
export class ProcessHook {

    class = "ProcessHook";

    @JsonProperty()
    declare id: string;

    @JsonProperty()
    declare transitions: Array<[number, number]>;

    constructor(props?: ProcessHookProps) {
        if (props) {
            Object.assign(this, props);
        }
    }

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    run(runProps: ProcessHookRunProps): Promise<any>{
        throw Error("ProcessHook is an abstract class. Please derive a specific class and implement run().");
    };

    /**
     * Convert to JSON
     */
    toJSON(): object | object[] | null | undefined {
        const serializer = new JsonSerializer({
            errorCallback: throwError
        });
        return serializer.serializeObject(this);
    }

}


